export const connectSideBarWidthInPercent = 34
export const connectSideBarMaxWidth = 550
export const responsiveConnectSidebarWidth = 480

export const TIM_AI_CHAT_ASSISTANT_NAME = "salesainew"
export const VAN_AI_CHAT_ASSISTANT_NAME = "hiringapp"

export const organizationName = "techolution"
export const aiModels = ["OpenAI", "GoogleAI", "Llama2"]
export const selectedAIModel = ""

export const userName = "Techowebsite"
export const userEmailId = "Techowebsite@techolution.com"
export const userId = "Techo-website-user-id"

export const TIM_AI_WELCOME_MSG = `Hello! I'm not a chatbot but your state-of-the-art, AI-powered assistant. I'm here to help you explore all the services Techolution has to offer. \n\n How can I assist you today?`
// export const TIM_AI_WELCOME_MSG = `Hi`
export const VAN_AI_WELCOME_MSG = `Hello! I'm Van - AI Recruiter, Techolution's AI-powered Hiring Assistant.\nHow may I help you today?`

// 2 minutes timeout for under reviews message to become normal message
export const COPILOT_NOTIFICATION_AUTO_TIMEOUT = 120000
